import { Component, OnInit } from '@angular/core';
import {
	UserDeviceRegistrationComponent
} from "@app/channels/auth/login/partials/sign-in/partials/user-device-registration/user-device-registration.component";
import {ScreenManagerService} from "@mpt-fo/common/core/services/screen-manager.service";
import {ProfileSetupService} from "@mpt-fo/common/core/services/profile-setup/profile-setup.service";
import {AuthenticationService} from "@mpt-fo/common/core/services/authentication.service";
import {DeviceHelperService} from "@mpt-fo/common/core/services/device-helper.service";
import {LoginHelperService} from "@mpt-fo/common/core/services/login-helper.service";
import {ModalService} from "@mpt-fo/common/lean-shared/components/nz-modal-service/modal.service";
import {LivelinessService} from "@mpt-fo/common/core/services/liveliness.service";
import { ClusterManagerManagementService } from '@mpt-fo/common/core/services/cluster-manager-management/cluster-manager-management.service';

@Component({
  selector: 'app-mobile-user-device-registration',
  templateUrl: './mobile-user-device-registration.component.html',
  styleUrls: ['./mobile-user-device-registration.component.scss']
})
export class MobileUserDeviceRegistrationComponent extends UserDeviceRegistrationComponent implements OnInit {

  constructor(
	  screenManager: ScreenManagerService,
	  profile: ProfileSetupService,
	  auth: AuthenticationService,
	  loginHelper: LoginHelperService,
	  deviceHelper: DeviceHelperService,
	  modalService: ModalService,
	  livelinessService: LivelinessService,
	  clusterManagerService: ClusterManagerManagementService,
	) {
	  super(screenManager, profile, auth, loginHelper, deviceHelper, modalService, livelinessService, clusterManagerService);
  }

  ngOnInit(): void {
	  this.initialize();
  }

	setOTPDescription(){
	  this.description = `We’ve just sent a 6-digit code to your registered
      phone number ${this.maskPhoneNumber}. Enter the code to proceed`;
	}

}
